import React, { useEffect } from "react";
const VolumeSlider = ({ audioEnv, volume, setVolume }) => {

    const handleVolume = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    useEffect(() => {
        const env = audioEnv;
        if (env) env.setGain(volume);
    }, [volume, audioEnv]);

    return (
        <div className="volume-slider-container container">
            <input className='volume-slider slider'
                type="range"
                min="0"
                max="1"
                step="0.01"
                value={volume}
                onChange={handleVolume} />
        </div>
    )
}

export default VolumeSlider